"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportCurrencyRates = exports.getCurrencyRates = exports.getConversionRate = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var moment_1 = tslib_1.__importDefault(require("moment"));
var tokenStorage_1 = tslib_1.__importDefault(require("./lib/tokenStorage"));
/**
 * Returns conversion rate between the passed currencies on the passed date.
 * E.g. '2018-09-04', USD, EUR will return '0,864342335'
 *
 *
 * @param {Date|string} date date for which to get the rates
 * @param {number} from from which currency the conversion takes place
 * @param {number} to to which currency the conversion takes place
 * @returns {Promise<number>} the rate of the conversion
 */
function getConversionRate(date, from, to) {
    var dateString = (0, moment_1.default)(new Date(date)).format('YYYY-MM-DD');
    return api_1.default
        .get("/api/currency-rates/conversion-rate?date=".concat(dateString, "&from=").concat(from, "&to=").concat(to))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getConversionRate = getConversionRate;
var api = {
    getConversionRate: getConversionRate,
};
function getCurrencyRates(month) {
    return api_1.default
        .get('/api/currency-rates?month=' + month)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getCurrencyRates = getCurrencyRates;
function exportCurrencyRates(month) {
    var token = tokenStorage_1.default.get();
    var url = "/api/currency-rates?month=".concat(month, "&export=true&token=").concat(token);
    window.open(url);
}
exports.exportCurrencyRates = exportCurrencyRates;
exports.default = api;
